import configTypes from './Config';

const accountContextRequiredConfig = [
    ...configTypes,
    'userRole',
    'user',
];

export default accountContextRequiredConfig;
